<template>
  <div class="animated fadeIn">
    <div>
      <b-row v-if="loading">
        <b-col md="6">
          <atom-spinner
            :animation-duration="1000"
            :size="60"
            color="#ff1d5e"
            class="float-right my-4"
          />
        </b-col>
      </b-row>
    </div>
    <div v-if="!loading">
      <b-row>
        <b-col md="4">
          <b-card
            header="Catalog tree"
            border-variant="info"
            header-bg-variant="primary"
            header-text-variant="white"
          >
            <div slot="header">
              <span data-font="22">Catalog</span>
            </div>
            <a-tree
              v-if="treeData.length > 0"
              :checkable="checkable"
              v-model="checkedKeys"
              @select="onSelect"
              :load-data="onLoadData"
              :treeData="treeData"
            />
          </b-card>
        </b-col>
        <b-col md="8" v-if="selectedCatalogObject">
          <b-card
            border-variant="info"
            header-bg-variant="primary"
            header-text-variant="white"
          >
            <div slot="header">
              <span data-font="22">Catalog Details</span>
              <button
                class="btn float-right ml-2 btn-danger mr-2"
                :disabled="iscreateButtonDisable"
                v-if="
                  userPermission.hasOwnProperty('DELETE_CATALOG') &&
                  !iscreateButtonDisable
                "
                @click="deleteCatalog"
              >
                <span class="font-weight-bold">Delete Catalog</span>
              </button>
              <button
                class="btn float-right btn-success"
                v-if="userPermission.hasOwnProperty('CATALOG_DETAIL')"
                @click="catalogDetails"
              >
                <span class="font-weight-bold">Details</span>
              </button>
              <button
                class="btn float-right btn-success mr-2"
                :disabled="iscreateButtonDisable"
                v-if="userPermission.hasOwnProperty('CREATE_CATALOG')"
                @click="$router.push({ path: '/catalog/create' })"
              >
                <span class="font-weight-bold">Create Catalog</span>
              </button>
            </div>
            <b-row class="font-md p-2">
              <b-col md="4">
                <span>Name</span>
              </b-col>
              <b-col md="8">
                <input
                  class="form-control"
                  :disabled="disabled"
                  :value="selectedCatalogObject.name"
                />
              </b-col>
            </b-row>

            <b-row class="font-md p-2">
              <b-col md="4">
                <span>Catalog Type</span>
              </b-col>
              <b-col md="8">
                <input
                  class="form-control"
                  :disabled="disabled"
                  :value="selectedCatalogObject.catalogType"
                />
              </b-col>
            </b-row>

            <b-row class="font-md p-2">
              <b-col md="4">
                <span>Display Name</span>
              </b-col>
              <b-col md="8">
                <input
                  class="form-control"
                  :disabled="disabled"
                  :value="selectedCatalogObject.catalogDescription.displayName"
                />
              </b-col>
            </b-row>

            <b-row class="font-md p-2">
              <b-col md="4">
                <span>Long Description</span>
              </b-col>
              <b-col md="8">
                <input
                  class="form-control"
                  :disabled="disabled"
                  :value="
                    selectedCatalogObject.catalogDescription.longDescription
                  "
                />
              </b-col>
            </b-row>

            <b-row class="font-md p-2">
              <b-col md="4">
                <span>Short Description</span>
              </b-col>
              <b-col md="8">
                <input
                  class="form-control"
                  :disabled="disabled"
                  :value="
                    selectedCatalogObject.catalogDescription.shortDescription
                  "
                />
              </b-col>
            </b-row>

            <b-row class="font-md p-2">
              <b-col md="4">
                <span>Attribute Count</span>
              </b-col>
              <b-col md="8">
                <input
                  class="form-control"
                  :disabled="disabled"
                  :value="selectedCatalogObject.externalAttributes.length"
                />
              </b-col>
            </b-row>
          </b-card>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { AtomSpinner } from "epic-spinners";

const getParentKey = (key, tree) => {
  let parentKey;
  for (let i = 0; i < tree.length; i++) {
    const node = tree[i];
    if (node.children) {
      if (node.children.some((item) => item.key === key)) {
        parentKey = node.key;
      } else if (getParentKey(key, node.children)) {
        parentKey = getParentKey(key, node.children);
      }
    }
  }
  return parentKey;
};

export default {
  name: "Catalog",
  components: {
    AtomSpinner,
  },
  data: () => {
    return {
      loading: false,
      iscreateButtonDisable: false,
      search: "",

      expandedKeys: [],
      autoExpandParent: true,
      checkedKeys: [],
      treeData: [],
      disabled: true,
      checkable: false,
      selectedCatalogObject: {
        catalogDescription: {
          displayName: "",
          longDescription: "",
          shortDescription: "",
        },
        externalAttributes: [],
      },
    };
  },
  methods: {
    onLoadData(event) {
      return new Promise((resolve) => {
        if (event.dataRef.children.length > 0) {
          resolve();
          return;
        } else {
          if (!event.dataRef.isProductType) {
            let searchString = event.dataRef.isRoot
              ? `isDomain=y&parent=${event.dataRef._id}`
              : `parent=${event.dataRef._id}`;
            this.$store
              .dispatch("catalog/fetchCatalogList", searchString)
              .then((result) => {
                if (result.data.status === 1) {
                  const dataArray = result.data.response;
                  if (dataArray && dataArray.length > 0) {
                    dataArray.map((obj) => {
                      event.dataRef.children.push({
                        ...obj,
                        title: obj.name,
                        key: obj._id,
                        children: [],
                        isLeaf: obj.isProductType,
                      });
                    });
                    this.$store.dispatch(
                      "catalog/updateCatalogTree",
                      this.treeData
                    );
                  }
                }
                resolve();
              });
          }
        }
      });
    },
    async generateTree() {
      this.loading = true;
      // it prepares a node structure necessary to render a tree view
      const makeNode = (catalog) => ({
        title: catalog.name,
        key: catalog._id,
        children: [],
        ...catalog,
      });
      // if updated tree available in vuex
      if (this.generatedTreeData.length > 0) {
        this.treeData = this.generatedTreeData;
      } else {
        let searchString = "isRoot=y";
        this.$store
          .dispatch("catalog/fetchCatalogList", searchString)
          .then((result) => {
            if (result.data.status === 1) {
              const dataArray = result.data.response;
              if (dataArray && dataArray.length > 0) {
                let rootCatalog = makeNode(dataArray[0]);
                this.treeData = [];
                this.treeData = [rootCatalog];
                this.$store.dispatch(
                  "catalog/updateCatalogTree",
                  this.treeData
                );
              }
            }
          });
      }
      this.loading = false;
    },
    onSelect(event, data) {
      this.selectedCatalogObject = data.node.dataRef;
      this.selectedCatalogObject.catalogType = data.node.dataRef.isCategory
        ? "Catalog layer"
        : data.node.dataRef.isDomain
        ? "Domain layer"
        : data.node.dataRef.isMarket
        ? "Market layer"
        : data.node.dataRef.isProductType
        ? "Product layer"
        : data.node.dataRef.isRoot
        ? "Root layer"
        : "";
    },
    onChange(e) {
      const value = e.target.value;
      const expandedKeys = this.treeData
        .map((item) => {
          if (item.key.indexOf(value) > -1) {
            return getParentKey(item.key, this.treeData);
          }
          return null;
        })
        .filter((item, i, self) => item && self.indexOf(item) === i);
      Object.assign(this, {
        expandedKeys,
        searchValue: value,
        autoExpandParent: true,
      });
    },
    deleteCatalog() {
      if (!this.selectedCatalogObject._id) {
        let errMessage = "Please select catalog...";
        this.$swal({
          title: "Sorry",
          text: errMessage,
          type: "error",
        });
      } else {
        this.$swal({
          title: "Delete this Catalog?",
          text: "Are you sure? You won't be able to revert this!",
          type: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          confirmButtonText: "Yes, Delete it!",
          cancelButtonColor: "#d33",
           reverseButtons: true,
        }).then((result) => {
          if (result.value) {
            const payload = {
              catalogId: this.selectedCatalogObject._id,
            };
            this.$store
              .dispatch("catalog/deleteCatalog", payload)
              .then((result) => {
                this.$toasted.success("Catalog Deleted Successfully");
                window.location.reload();
              });
          }
        });
      }
    },
    catalogDetails() {
      if (!this.selectedCatalogObject._id) {
        let errMessage = "Please select catalog...";
        this.$swal({
          title: "Sorry",
          text: errMessage,
          type: "error",
        });
      } else {
        this.$router.push({
          name: "CatalogDetails",
          params: { id: this.selectedCatalogObject._id },
        });
      }
    },
  },
  mounted: async function () {
    this.generateTree();
  },
  computed: {
    ...mapGetters({
      generatedTreeData: "catalog/GetGeneratedCatalog",
    }),
    catalog() {
      return this.selectedCatalogObject ? this.selectedCatalogObject._id : null;
    },
    totalRows() {
      return this.getRowCount();
    },
    captions() {
      return this.fields;
    },
    userPermission() {
      return this.$store.getters["auth/getUserPermissions"];
    },
  },
};
</script>
<style scoped>
.fa-plus {
  border-top-right-radius: 10px;
  border-top-left-radius: 17px;
  border-bottom-left-radius: 17px;
  background-color: #f0f3f5;
}
</style>
